import LAbsolute from './src/main'

/* istanbul ignore next */
LAbsolute.install = function(Vue) {
  Vue.component(LAbsolute.name, LAbsolute)
}

export default LAbsolute
